<div class="flex flex-col items-center py-4 px-2 sm:px-6 animate-fade-in">
  <!-- Logo -->
  <div class="mb-10">
    <img src="assets/images/logo/logo-landscape.png" alt="Wine Passport Logo" class="h-20">
  </div>

  <!-- Title -->
  <h2 class="text-2xl font-bold text-metro-blue mb-8 font-sans">
    Registrarte
  </h2>

  <!-- Google Button -->
  <div class="w-full max-w-sm mb-6">
    <app-metro-button 
      variant="secondary" 
      [icon]="iconGoogle"
      iconColor="#4285F4"
      (clicked)="registerWithGoogle()" 
      text="Registrarse con Google">
    </app-metro-button>
  </div>

  <!-- Separator -->
  <div class="w-full max-w-sm flex items-center mb-6">
    <div class="flex-grow border-t border-[#e2e8f0]"></div>
    <div class="mx-3 flex items-center justify-center">
      <div class="w-2 h-2 rounded-full border border-[#e2e8f0]"></div>
    </div>
    <div class="flex-grow border-t border-[#e2e8f0]"></div>
  </div>

  <!-- Email Button -->
  <div class="w-full max-w-sm">
    <app-metro-button 
      variant="primary"
      (clicked)="onContinueWithEmail()" 
      text="Crear cuenta con email">
    </app-metro-button>
  </div>
</div>
